import { Link } from 'react-router-dom';
import { articles } from '@/mocks/categories';

const latestArticles = articles.slice(0, 3);

export default function LatestArticlesSection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新文章
            </h2>
            <p className="text-foreground-500 text-sm">
              最新的访问指南、安全资讯和使用教程
            </p>
          </div>
          <Link
            to="/category/latest-address"
            className="hidden sm:flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line w-3 h-3 flex items-center justify-center"></i>
                    {article.readTime}
                  </span>
                  <span className="text-xs text-foreground-400">
                    {article.publishDate}
                  </span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2 group-hover:text-primary-700 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/latest-address"
            className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}